module.exports = __webpack_public_path__ + "static/media/companyVideo.33fe0451.mkv";